/*
 * @Author: Src
 * @Date: 2026-09-01 14:27:11
 * @LastEditTime: 2026-09-11 15:16:54
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/supplyChainRouter/platformRoutes.ts
 * @Description: 平台管理模块
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import DistributorList from '@/views/supplyChain/platform/DistributorList.vue';
import SupplierManagement from '@/views/supplyChain/platform/SupplierManagement.vue';
// import DistrictManagement from '@/views/supplyChain/platform/DistrictManagement.vue';

import InvoiceManagement from '@/views/supplyChain/platform/InvoiceManagement.vue';
import GoodsList from '@/views/supplyChain/platform/GoodsList.vue';
import PlatformPurchaseOrder from '@/views/supplyChain/platform/PlatformPurchaseOrder.vue';
import PlatformSalesOrder from '@/views/supplyChain/platform/PlatformSalesOrder.vue';
import { AuthEnum } from '@/services/permission.service';

const platformRoutes: RouteConfig = {
    path: '/platform',
    name: 'platform',
    component: Main,
    meta: { title: '平台管理' },
    redirect: {
      name: 'distributorList',
    },
    children: [
      {
        path: 'list',
        name: 'distributorList',
        component: DistributorList,
        meta: { title: '经销商管理 ' },
        props: {
          auth: [AuthEnum.经销商管理],
        },
      },
      {
        path: 'supplier',
        name: 'supplierManagement',
        component: SupplierManagement,
        meta: { title: '供应商管理 ' },
        props: {
          auth: [AuthEnum.供应商管理],
        },
      },
      {
        path: 'order',
        name: 'platformSalesOrder',
        component: PlatformSalesOrder,
        meta: { title: '平台销售单' },
        props: {
          auth: [AuthEnum.平台销售单],
        },
      },
      {
        path: 'purchase',
        name: 'platformPurchaseOrder',
        component: PlatformPurchaseOrder,
        props: {
          auth: [AuthEnum.平台采购单],
        },
        meta: { title: '平台采购单' },
      },
      {
        path: 'goods',
        name: 'goodsList',
        component: GoodsList,
        props: {
          auth: [AuthEnum.商品管理],
        },
        meta: { title: '商品管理 ' },
      },
      {
        path: 'invoice',
        name: 'invoiceManagement',
        props: {
          auth: [AuthEnum.供应链发票管理],
        },
        component: InvoiceManagement,
        meta: { title: '发票管理 ' },
      },
    ],
  };
export default platformRoutes;
